import {map} from 'lodash'
// ** Imports createContext function
import { createContext } from 'react'

// ** Imports createContextualCan function
import { createContextualCan } from '@casl/react'

// ** Create Context
export const AbilityContext = createContext()

// ** Init Can Context
export const Can = createContextualCan(AbilityContext.Consumer)

export const _hasAnyAbility = (ability, resources = [], action = 'call') => {
  let has = false
  map(resources, (v, k) => {
    if (ability.can(action, v)) {
      has = true
      return false
    }
  })
  return has

}